<template>
  <div class="s-btn" :class="{'grey': !canUse, 'blue': blue}" @click="confirm">
    {{text}}
  </div>
</template>

<script>
export default {
  name: 'ShortBtn',
  props: {
    // 按钮文字信息
    text: {
      type: String,
      default: '确认',
    },
    // 是否可用
    canUse: {
      type: Boolean,
      default: true,
    },
    blue: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    // 按钮点击
    confirm() {
      if (!this.canUse) return
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "../../style/main";

  .s-btn {
    width: use(274);
    height: use(66);
    font-weight: bold;
    font-size: use(28);
    line-height: use(66);
    color: #FFFFFF;
    background-image: linear-gradient(135deg, #FF9C51 0%, #FF6914 100%);
    box-shadow: 0 use(10) use(20) 0 rgba(255, 115, 40, 0.50);
    border-radius: use(100);
    text-align: center;
    margin: 0 auto;
    letter-spacing: use(4);

    &.grey {
      background-image: linear-gradient(135deg, #CFCFCF 0%, #C2C2C2 100%);
      box-shadow: 0 use(10) use(20) 0 rgba(201, 201, 201, 0.50);
    }

    &.blue {
      background-image: linear-gradient(135deg, #56C3F2 0%, #3BA8FF 100%);
      box-shadow: 0 use(10) use(20) 0 rgba(181, 222, 255, 0.50);
      border-radius: rem(5);
    }

  }
</style>
